import catalogEffectManager from '../effect/catalog';

let effect;

/* ---------------------------------------

    -- スクロール位置で発火するやつはここ

--------------------------------------- */
export default class catalogAnimation{
    constructor(param){

        effect = new catalogEffectManager();

        this.$target = document.querySelectorAll('.js__tsc');
        this.scPoint = [];
        this.scNum = this.$target.length;

        let _splitText = document.getElementsByClassName("js__tsc-splittext");
        let _show = document.getElementsByClassName("js__tsc-show");
        let _showScale = document.getElementsByClassName("js__tsc-showscale");
        let _showX = document.getElementsByClassName("js__tsc-show-x");
        let _showX2 = document.getElementsByClassName("js__tsc-show-x2");
        let _showY = document.getElementsByClassName("js__tsc-show-y");
        let _showXslow = document.getElementsByClassName("js__tsc-show-x-slow");
        let _showLine = document.getElementsByClassName("js__tsc-show-line");
        let _feature = document.getElementsByClassName("js__tsc-show-feature");

        if(_splitText != null) effect.splitText(_splitText,"set");
        if(_show != null) effect.show(_show,"set");
        if(_showScale != null) effect.showScale(_showScale,"set");
        if(_showX != null) effect.showX(_showX,"set");
        if(_showX2 != null) effect.showX2(_showX2,"set");
        if(_showY != null) effect.showY(_showY,"set");
        if(_showXslow != null) effect.showXslow(_showXslow,"set");
        if(_showLine != null) effect.showLine(_showLine,"set");
        if(_feature != null) effect.feature(_feature,"set");

        this.resize();

        this.status = {
            comp : false /* 全部処理が終わったか */
        }

        this.param = param;

    }
    check(inc,winH){
        if(this.status.comp) return;

        let _minusPoint = (Useragnt.pc && this.param.browserType !== 'IE')?winH/1.5:winH;

        if(this.$target){
            for(var i=0; this.scNum>i; i++){

                if(this.scPoint[i] - _minusPoint < inc  ) {
                    let $scp = this.$target[i];
                    if(!$scp.classList.contains("is-show")){
                        $scp.classList.add("is-show");

                        let _splitText = $scp.querySelectorAll(".js__tsc-splittext >* >*");
                        let _show = $scp.querySelectorAll(".js__tsc-show");
                        let _showSlow = $scp.querySelectorAll(".js__tsc-showslow");
                        let _showScale = $scp.querySelectorAll(".js__tsc-showscale");
                        let _showX = $scp.querySelectorAll(".js__tsc-show-x");
                        let _showX2 = $scp.querySelectorAll(".js__tsc-show-x2");
                        let _showY = $scp.querySelectorAll(".js__tsc-show-y");
                        let _showXslow = $scp.querySelectorAll(".js__tsc-show-x-slow");
                        let _showLine = $scp.querySelectorAll(".js__tsc-show-line");
                        let _feature = $scp.querySelectorAll(".js__tsc-show-feature");

                        if(_splitText != null) effect.splitText(_splitText,"show");
                        if(_show != null) effect.show(_show,"show");
                        if(_showSlow != null) effect.showScale(_showScale,"show");
                        if(_showScale != null) effect.showSlow(_showSlow,"show");
                        if(_showX != null) effect.showX(_showX,"show");
                        if(_showX2 != null) effect.showX2(_showX2,"show");
                        if(_showY != null) effect.showY(_showY,"show");
                        if(_showXslow != null) effect.showXslow(_showXslow,"show");
                        if(_showLine != null) effect.showLine(_showLine,"show");
                        if(_feature != null) effect.feature(_feature,"show");

                        if(i==this.$target.length-1) this.status.comp = true;

                    }

                }

            }

        }

    }

    resize (_h) {

        if(this.$target){

            this.scPoint = [];
            for( var i=0; i<this.scNum; i++) {

                let $scp = this.$target[i];

                this.scPoint[i] = $scp.getBoundingClientRect().top;
            }
        }

    }
}